
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";

import * as model from '../../data/model';
import Button from "src/components/CustomButtons/Button.jsx";
import * as types from '../../types'
import {  Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@material-ui/core";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as track from '../../data/track/track';
const styles : any = theme => ({
    

});

interface SubscribeDialogProps {
    classes: any;
    connect: types.IState,
    podcast_id:any,
    open:boolean;
    close:()=>void;
}
interface SubscribeDialogState {
    copied:boolean;
}
class SubscribeDialog extends React.Component<SubscribeDialogProps, SubscribeDialogState> {
    
   
    constructor(props: SubscribeDialogProps) {
        super(props);

        this.state = {
            copied:false

        };
       
    }
    componentWillReceiveProps(props: SubscribeDialogProps) {
        if(props.open && !this.props.open)
        {
            track.Track.ModelView("SubscribeModal")
           
        }
        
    }
    render() {
        const { classes } = this.props;
        let me = this;
        let isMobile = true;
        let podcast = this.props.connect.lo_PodCasts.val().find(x=>x.id==this.props.podcast_id);
        if(!podcast)
        {
            return (<span></span>)
        }
        return (
            <Dialog
            fullWidth={true}
            maxWidth="md"
            open={this.props.open}
            onClose={this.props.close}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">{"How to add your feed url to your podcast app"}</DialogTitle>
            <DialogContent>
                <DialogContentText>

                    <div>Your feed url tells your podcast app how to play your podcast.</div>
                    <GridContainer justify="center" alignItems="center"
                    >
                        <GridItem xs={12} sm={12} md={12} lg={12}>
                            <CustomInput
                                variant="outlined"
                                labelText={
                                    <span>Feed URL
      </span>
                                }
                                id="email"
                                formControlProps={{
                                    fullWidth: true
                                }}

                                inputProps={{

                                    disabled: true,
                                    value: podcast.feed_url
                                }}
                            />
                        </GridItem>
                    </GridContainer>



                    <GridContainer
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                    >
                        <GridItem alignContent='center' alignItems='center' xs={12} sm={12} md={12} lg={12} className={styles.center}>
                            <CopyToClipboard text={podcast.feed_url}
                                onCopy={() => {
                                     this.setState({ copied: true });
                                     track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.subscribeUrlCopy);
                                    }} >
                                <Button color="primary">Copy Feed URL To Clipboard</Button>
                            </CopyToClipboard>


                        </GridItem >
                        <GridItem xs={12} sm={12} md={12} lg={12}>

                            {this.state.copied ? <span style={{ color: 'green' }}>Copied to clipboard.</span> : null}
                        </GridItem>
                    </GridContainer>


                    <h5>iTunes (Mac & Windows)</h5>
                    <div>
                        Click on “File” in the top left menu. Then select “Subscribe to Podcast…” from the dropdown and paste the feed URL. Click ok and voilà!
</div>
                    <h5> Podcasts App (iOS)</h5>
                    <div>
                        Tap the “My Podcasts” button on the bottom row of icons. Then hit the + button in the top left corner, and select “Add Podcast” from the pop up. Then you paste in the feed URL and hit subscribe.
                </div>
                    <h5>Pocket Casts (iOS, Android & Web)</h5>
                    <div>
                        {isMobile &&

                            <div>
                                <a href="pktc://subscribe/{podcast.feed_url}">  Click to add to Pocket Cast</a> If that doesn't work then
</div>
                        }
                        Paste the feel URL of the feed into the search field and hit search!
               </div>
                    <h5>Overcast (iOS & Web)</h5>
                    <div>
                        Tap the + button in the top right like you normally would to add a podcast. Then tap “Add URL” in the top right, paste the feed URL and hit done!
                </div>
                    <h5>Podcast Addict (Android)</h5>
                    <div>Tap the + sign in the top right. Then choose”Add RSS Feed” and paste in the URL of the RSS feed. Tap “Add.”
                </div>
                    <h5>Downcast (iOS & Mac)</h5>
                    <div>Tap “Add” on the bottom bar, press “Add Podcast Manually” and in the “Feed” field paste the URL of the RSS feed. Then hit “Subscribe” in the top right.
                </div>
                    <h5>Podcast apps that do not support manual RSS</h5>
                    <div>Currently it is not possible to manually add a RSS feed to Google Play Music, Spotify or iHeartRadio 😔
                </div>

                </DialogContentText>
            </DialogContent>
            <DialogActions>



                <Button onClick={this.props.close} simple color="primary" autoFocus>
                    Close
    </Button>
            </DialogActions>
        </Dialog>
   
            );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(SubscribeDialog));







// WEBPACK FOOTER //
// ./src/views/podcast/SubscribeDialog.tsx